export const GETMASSAGEREMAIL="GETMASSAGEREMAIL";
export const GETMASSAGERID = "GETMASSAGERID";